
import Vue from "vue";
import AppSplitter from "./Splitter.vue";
export default Vue.extend({
	data() {
		return {
			height: this.value - 2
		};
	},
	props: {
		value: {
			type: Number,
			required: true
		},
		useBottom: Boolean
	},
	computed: {
		diff() :number {
			return 2;
		}
	},
	watch: {
		height(value:number) {
			if(this.value != value + this.diff ) {
				this.$emit("input", value + this.diff);
			}
		},
		value(value:number) {
			if (this.value != this.height + this.diff) {
				this.height = this.value - this.diff;
			}
		}
	},
	components: {
		AppSplitter
	}
});
